<script>
// Header del dashboard — Estilo APPMISIONATE
import HeaderComponent from '../features/HeaderComponent';
import SessionBoxView from '../views/SessionBoxView';
import NotificationAlertsView from '../views/NotificationAlertsView';

export default {
  name: 'HeaderView',
  components: {
    'session-box-view': SessionBoxView,
    'notification-alerts-view': NotificationAlertsView,
  },
  mixins: [HeaderComponent],
  computed: {
    isStudentRoute() {
      return this.$route && this.$route.path && this.$route.path.startsWith('/estudiante');
    },
    isAdminRoute() {
      return this.$route && this.$route.path && this.$route.path.startsWith('/admin');
    },
    shouldHideHeader() {
      return this.isStudentRoute || this.isAdminRoute;
    },
  },
  watch: {
    $route() {
      this.syncBodyHeaderClass();
    },
  },
  mounted() {
    this.syncBodyHeaderClass();
  },
  unmounted() {
    document.body.classList.remove('has-dashboard-header');
  },
  methods: {
    syncBodyHeaderClass() {
      if (this.shouldHideHeader) {
        document.body.classList.remove('has-dashboard-header');
      } else {
        document.body.classList.add('has-dashboard-header');
      }
    },
    onToggleSidebar() {
      const sidebar = document.getElementById('sidebarAp');
      const header = document.getElementById('dashboardHeader');
      const wrappers = document.querySelectorAll('.wrapper');
      if (sidebar) sidebar.classList.toggle('collapsed');
      if (header) header.classList.toggle('sidebar-collapsed');
      wrappers.forEach(w => w.classList.toggle('sidebar-collapsed'));
    },
  },
};
</script>

<template>
  <!-- Header Start — estilo APPMISIONATE (Solo para rutas con cabecera superior activa, e.g. Profesor) -->
  <header
    v-if="!shouldHideHeader"
    id="dashboardHeader"
    class="dashboard-header-ap"
  >
    <div class="dh-left">
      <button
        id="toggleMenu"
        class="toggle-sidebar-btn"
        title="Abrir menú"
        aria-label="Abrir menú"
        @click="onToggleSidebar"
      >
        <i
          class="fas fa-bars"
          style="font-size:1rem;"
        />
      </button>
    </div>

    <div class="dh-right">
      <span
        v-if="showProgress"
        style="display:flex; align-items:center; gap:10px; margin-right:8px;"
      >
        <span style="font-size:.8rem; color:var(--ct3); font-weight:600;">Progreso</span>
        <el-progress
          type="circle"
          :color="courseProgressColors"
          :percentage="progressPercentage"
          :width="38"
        />
      </span>

      <notification-alerts-view />

      <session-box-view />
    </div>
  </header>
  <!-- Header End -->
</template>

<style scoped>
/* Scoped overrides para el header del dashboard */
.dashboard-header-ap {
  position: fixed !important;
  top: 0 !important;
  left: 260px !important;
  right: 0 !important;
  width: auto !important;
  height: 64px !important;
  background: #ffffff !important;
  backdrop-filter: blur(12px);
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0,0,0,.05);
  z-index: 1000 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 0 24px !important;
  transition: left .25s cubic-bezier(.4,0,.2,1);
}
.dashboard-header-ap.sidebar-collapsed {
  left: 64px !important;
}
.dashboard-header-ap .toggle-sidebar-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  color: #6b7280;
  border-radius: 8px;
  cursor: pointer;
  transition: all .15s ease;
}
.dashboard-header-ap .toggle-sidebar-btn:hover {
  background: #f3f4f6;
  color: #1f2937;
}
.dashboard-header-ap .dh-right {
  display: flex;
  align-items: center;
  gap: 12px;
}
</style>
